import React from 'react';

const ContactFormWidget = (props: any) => {
  return (
    <div className="ContactFormWidget-container ">
      <div className="container">
        <div className="ContactFormWidget-flexbox-content">
          <div>
            <h2 className="ContactFormWidget-h2">{props.data?.title}</h2>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: props.data?.description }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFormWidget;
